import { makeAutoObservable, runInAction } from "mobx"
import agent from "../api/agent"

export interface IAutomationRecommendation {
    recommendation: string[];
    remark: string;
    systemName: string;
    tagNumber: string
    hover: string[];
}

export class HomeAutoRecommendStore {
    automationRecommendation: IAutomationRecommendation[] = []
    loadingAutomation = false

    constructor() {
        makeAutoObservable(this)
    }

    getAutomationRecomendation = async (stationId: string) => {
        this.loadingAutomation = true
        try {
            const res = await agent.Dashboard.getAutomationRecommendation(stationId)
            
            runInAction(() => this.automationRecommendation = res)
        } catch (error) {
            throw error
        } finally {
            runInAction(() => this.loadingAutomation = false)
        }
    }
}